import { render, staticRenderFns } from "./Preference.vue?vue&type=template&id=60838f9d&scoped=true"
import script from "./Preference.vue?vue&type=script&lang=js"
export * from "./Preference.vue?vue&type=script&lang=js"
import style0 from "./Preference.vue?vue&type=style&index=0&id=60838f9d&lang=scss&scoped=true"
import style1 from "./Preference.vue?vue&type=style&index=1&id=60838f9d&scoped=true&lang=css"
import style2 from "./Preference.vue?vue&type=style&index=2&id=60838f9d&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60838f9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60838f9d')) {
      api.createRecord('60838f9d', component.options)
    } else {
      api.reload('60838f9d', component.options)
    }
    module.hot.accept("./Preference.vue?vue&type=template&id=60838f9d&scoped=true", function () {
      api.rerender('60838f9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/Preference.vue"
export default component.exports